export class Station {
    StationId: number = 0;
    StationName: string;
    Order: number;
    Status: boolean = true;
    UserId: string;
}